import React from 'react';

import RecentTestCycles from '@qality/common-components/src/gadgets/RecentTestCycles';
import TestExecutionGadget from '@qality/common-components/src/gadgets/TestExecutionGadget/TestExecutionGadget';
import UnfinishedTestCaseExecutions from '@qality/common-components/src/gadgets/UnfinishedTestCaseExecutions';
import { DashboardListBanner } from '@qality/common-components/src/organisms/DashboardListBanner';
import { DashboardOnboarding } from '@qality/common-components/src/organisms/DashboardOnboarding';
import { FEATURE_FLAG } from '@qality/common-config';

import {
  DashboardItem,
  DashboardItemsContainer,
  DashboardItemsWrapper,
  DashboardOnboardingContainer,
} from './Gadgets.styled';

interface GadgetsViewProps {
  projectId: string;
  isQAlityConfigured: boolean;
  isOnboardingGadgetOpened: boolean;
}

export const GadgetsView: React.FC<GadgetsViewProps> = ({
  projectId,
  isQAlityConfigured,
  isOnboardingGadgetOpened,
}: GadgetsViewProps) => {
  return (
    <>
      <DashboardItemsWrapper>
        <DashboardItemsContainer>
          {isQAlityConfigured && FEATURE_FLAG.isPremium && (
            <UnfinishedTestCaseExecutions />
          )}
          <DashboardItem>
            <TestExecutionGadget isQAlityConfigured={isQAlityConfigured} />
          </DashboardItem>
          {FEATURE_FLAG.isPremium && (
            <DashboardItem>
              <RecentTestCycles
                projectId={projectId}
                isQAlityConfigured={isQAlityConfigured}
              />
            </DashboardItem>
          )}
          <DashboardItem>
            <DashboardListBanner showBanner={!FEATURE_FLAG.isPremium} />
          </DashboardItem>
        </DashboardItemsContainer>
        <DashboardOnboardingContainer
          isOnboardingGadgetOpened={isOnboardingGadgetOpened}
        >
          <DashboardOnboarding />
        </DashboardOnboardingContainer>
      </DashboardItemsWrapper>
    </>
  );
};
